import React from 'react';
import { useAppContext } from '@/hooks/useAppContext';
import { getAppSettings } from '@/shared/getAppSettings';
import { getCurrentUri } from '@/utils/getCurrentUri';
import { encodeSitemapUrl } from '@/utils/url/sitemapUrlUtils';
import { LanguageOutlined } from '@zbanx/icons';
import { useTranslation } from 'react-i18next';
import { Link } from 'umi';
import css from './index.less';

export interface Props {
  style?: React.CSSProperties;
  className?: string;
}

export const Footer: React.FC<Props> = ({ style, className }) => {
  const { t } = useTranslation();
  const { language } = useAppContext();
  const classNames = [css.footer];
  const appSettings = getAppSettings();
  const domain =
    language === 'zh-CN' ? appSettings.enSiteDomain : appSettings.cnSiteDomain;
  const [url, setUrl] = React.useState<string>(domain);

  React.useEffect(() => {
    setUrl(`${domain}${getCurrentUri()}`);
  }, [domain]);

  if (className) {
    classNames.push(className);
  }

  return (
    <footer id="page-footer" className={classNames.join(' ')} style={style}>
      <ul className={css.list}>
        <li>
          <Link to="/about/about-us">{t('biz.app.footer.about')}</Link>
        </li>
        {/*
        // #3883 隐藏YouTube链接
        // https://zbanx.coding.net/p/zbanx-v2/iterations/3351/issues/3883
        <li>
          <Link to="/partner/youtubers">{t('biz.app.footer.influencers')}</Link>
        </li>
        */}
        <li>
          <Link to="/about/terms">{t('biz.app.footer.terms')}</Link>
        </li>
        <li>
          <Link to="/about/privacy">{t('biz.app.footer.privacy')}</Link>
        </li>
        <li>
          <Link to="/about/contact-us">{t('biz.app.footer.contact')}</Link>
        </li>
        {/* <li>
          <Link to="/sitemap/categories-selected_1_100">
            {t('biz.app.footer.categories')}
          </Link>
        </li>
        <li>
          <Link to="/sitemap/brands-selected_1_100">
            {t('biz.app.footer.brands')}
          </Link>
        </li>
        <li>
          <Link to="/sitemap/youtubers-youTuber_selected_1_100">
            {t('biz.app.footer.youtube')}
          </Link>
        </li> */}
        <li>
          <Link to={encodeSitemapUrl({ tab: 'categories' })}>
            {t('biz.app.footer.SiteMap')}
          </Link>
        </li>
        <li>
          <Link to="/about/faq">{t('biz.app.footer.FAQ')}</Link>
        </li>
        {/*
        #3768 去掉中英文主动切换按钮
        https://zbanx.coding.net/p/zbanx-v2/requirements/issues/3768/detail
        <li>
          <a
            className={css.lang}
            title="Change language"
            href={url}
            onClick={(e) => {
              e.preventDefault();
              window.location.href = `${domain}${getCurrentUri()}`;
            }}
          >
            <LanguageOutlined />
          </a>
        </li>
        */}
      </ul>
      <div className={css.icp}>
        <span>
          Copyright © {new Date().getFullYear()} ZBANX. All Rights Reserved.
        </span>
      </div>
    </footer>
  );
};

export default Footer;
